import React from "react";
import { Avatar, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { Container } from "@mui/system";
import UserSettings from "./UserSettings";
import { useContext, Context } from "../../Context";
import MessageModal from "../../components/MessageModal";
import Zoom from "@mui/material/Zoom";
import UploadImage from "../../components/UploadImage";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { URL, origin } from "../../config";
import { Helmet } from "react-helmet-async";

export default function Profile() {
    const { userName } = useContext(Context);
    const [userInfo, setUserInfo] = React.useState();
    const [error, setError] = React.useState("");
    const [open, setOpenUploadImage] = React.useState(false);
    const theme = useTheme();
    const navigate = useNavigate();

    const closeAlert = () => {
        setError("");
    };

    const closeUploadImage = () => {
        setOpenUploadImage(false);
    };

    const openUploadImage = () => {
        setOpenUploadImage(true);
    };

    React.useEffect(() => {
        fetch(`${URL}/user?` + new URLSearchParams({ username: userName }), {
            method: "GET",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
        })
            .then(async (response) => {
                return {
                    data: await response.json(),
                    code: response.status,
                };
            })
            .then((data) => {
                if (data.code !== 200) {
                    setError(data.data.message);
                    navigate(`/${data.code}`);
                    throw new Error(data.data.message);
                } else {
                    setUserInfo(data.data);
                }
            });
    }, []);

    return (
        <>
            <Helmet>
                <title>WealthWatch | profile</title>
            </Helmet>
            <Container maxWidth="md" sx={{ p: 6 }}>
                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                    container
                    spacing={3}
                >
                    <Tooltip
                        title="edit picture"
                        arrow
                        TransitionComponent={Zoom}
                        followCursor
                    >
                        <IconButton
                            sx={{ "&:hover": { color: "black" } }}
                            onClick={openUploadImage}
                        >
                            <Avatar
                                src={userInfo ? userInfo.imgurl : ""}
                                sx={{
                                    height: "100px",
                                    width: "100px",
                                    color: theme.palette.primary.light,
                                }}
                            ></Avatar>
                        </IconButton>
                    </Tooltip>
                    <Typography color={"primary.contrastText"} variant="h6">
                        {userInfo ? userInfo.username : ""}
                    </Typography>
                    <UserSettings />
                </Grid>
                <MessageModal
                    severity="error"
                    title="error"
                    open={error ? true : false}
                    onClose={closeAlert}
                >
                    {error}
                </MessageModal>
                <UploadImage
                    open={open}
                    onClose={closeUploadImage}
                    delete={userInfo ? (userInfo.imgurl ? true : false) : false}
                />
            </Container>
        </>
    );
}
